module.exports = __webpack_public_path__ + "img/apply-detailPic2.c57eeda.webp";